/****************************************************
 * Module Name:  stoneSelectionModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, Button, Container, TextField } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import logo from '../../images/pansuriya.jpg'
import Utility from "../../utility/utility";

const StoneSelectionModal = ({ handleSave, handleClose, show, title }) => {
    const [data, setData] = useState("");

    const handleClick = () => {
        let values = [];
        data.replaceAll('\n', ',').replaceAll(' ', ',').split(',').forEach((e) => {
            if (e && e !== '') {
                values.push(e)
            }
        });
        handleSave(values)
        handleClose()
    }

    return (
        <div>
            <Modal backdrop="static" show={show} onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;{title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container maxWidth="xxl">
                        <Box
                            sx={{
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                height: "20vh",
                            }}
                        >
                            <TextField
                                margin="normal"
                                fullWidth
                                multiline
                                rows={4}
                                label={title}
                                placeholder={title}
                                value={data}
                                onChange={(e) =>
                                    setData(
                                        Utility.ConvertNewLineToComma(e.target.value)
                                    )
                                }
                            />
                        </Box>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button sx={{ mr: 1 }} variant="contained" color="info" onClick={handleClick}>
                        Submit
                    </Button>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default StoneSelectionModal;
